import{purry as e}from"./purry-DH9cw9sy.js";function t(...t){return e(Object.fromEntries,t)}export{t as fromEntries};
//# sourceMappingURL=fromEntries-BAoo2mmx.js.map